import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { State } from "../reducers";
import { AVAILABLE_PERMISSIONS } from '../services/permissions'

import {
  loginSucess,
  login,
  logout,
  logoutSucess,
} from "../actions/news.actions";

const SERVER_URL = environment.SERVER_URL;

@Injectable({
  providedIn: "root",
})
export class RoleService {
  username = null;
  role;
  terms;

  constructor(
    private http: HttpClient,
    private router: Router,
    private store: Store<State>
  ) {}

  public createRole(name, roles) {
    const httpOptions: any = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    const payload = {
      name,
    };
    for (const role of roles) {
      payload[role] = true;
    }

    return this.http
      .post(`${SERVER_URL}/role`, payload, httpOptions)
      .toPromise()
      .then((data: any) => {
        console.log("finished uploading role");
      });
  }

  public async updateRole(name: string, roles: string[], id: string): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
  
    // Initialize payload with all permissions set to false
    const payload: any = {
      name,
      id,
    };
    
    // First set all permissions to false
    AVAILABLE_PERMISSIONS.forEach(permission => {
      payload[permission] = false;
    });
  
    // Then set selected permissions to true
    roles.forEach(role => {
      payload[role] = true;
    });
  
    console.log('Updating role with payload:', payload);
  
    return this.http
      .put(`${SERVER_URL}/role/${id}`, payload, httpOptions)
      .toPromise()
      .then((response: any) => {
        console.log("Role updated successfully:", response);
        return response;
      })
      .catch(error => {
        console.error("Error updating role:", error);
        throw error;
      });
  }  
  public deleteRole(id) {
    return this.http.delete(`${SERVER_URL}/role/${id}`).toPromise();
  }

  public getRole(id) {
    return this.http.get(`${SERVER_URL}/role/${id}`).toPromise();
  }
  public getRoleByName(name) {
    return this.http.get(`${SERVER_URL}/role/byName/${name}`);
  }

  public getRoles() {
      return this.http.get(`${SERVER_URL}/role`).toPromise();
  
  }
  public async getRolesP(): Promise<string[]> {
    try {
      const roles = await this.http.get<any[]>(`${SERVER_URL}/role`).toPromise();
      return roles.map(role => role.name) || [];
    } catch (error) {
      console.error('Error fetching roles:', error);
      return [];
    }
  }
}
